/* ============================================================
   TU Strandkorb Landing Page — JS
   ============================================================
   Funktionen:
   - Variant-Picker (Stoff + Lieferung) mit Preis-Update
   - Checkbox-Pattern (Spedition-Telefon-Bestätigung)
   - Add-to-Cart via /cart/add.js + Cart-Drawer-Refresh
   - FAQ-Accordion
   ============================================================ */

(function () {
  'use strict';

  // Wait for DOM
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    const root = document.querySelector('[data-tu-skl]');
    if (!root) return;

    // ============================================================
    // 1. PRODUCT CARD — Variant Switching + Checkbox + Add-to-Cart
    // ============================================================
    // (wird in Schritt 5 implementiert, wenn die Product-Card-Liquid steht)
    initProductCards(root);

    // ============================================================
    // 2. FAQ Accordion
    // ============================================================
    // (wird in Schritt 11 implementiert)
    initFaq(root);

    // ============================================================
    // 3. Lazy Fade-Ins beim Scrollen
    // ============================================================
    initFadeIns(root);
  });

  // ------------------------------------------------------------
  // Product Cards
  // ------------------------------------------------------------
  function initProductCards(root) {
    const cards = root.querySelectorAll('[data-skl-product-card]');
    if (!cards.length) return;

    cards.forEach(function (card) {
      initCardVariantPicker(card);
      initCardCheckbox(card);
      initCardAddToCart(card);
      resolveVariant(card);
    });
  }

  // ---------- Variant Picker ----------
  function initCardVariantPicker(card) {
    const swatches = card.querySelectorAll('[data-skl-swatch]');
    const deliveryBtns = card.querySelectorAll('[data-skl-delivery]');

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        swatches.forEach((s) => s.classList.remove('is-active'));
        sw.classList.add('is-active');
        resolveVariant(card);
      });
    });

    deliveryBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        deliveryBtns.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        resolveVariant(card);
      });
    });
  }

  function resolveVariant(card) {
    const activeSwatch = card.querySelector('[data-skl-swatch].is-active');
    const activeDelivery = card.querySelector('[data-skl-delivery].is-active');
    if (!activeSwatch) return;

    if (!card._sklVariants) {
      const jsonEl = card.querySelector('[data-skl-variants]');
      if (!jsonEl) {
        console.warn('[tu-skl] no variant JSON found');
        return;
      }
      try {
        const raw = jsonEl.textContent.trim();
        card._sklVariants = JSON.parse(raw).variants;
      } catch (e) {
        console.error('[tu-skl] variant JSON parse error', e, jsonEl.textContent.substring(0, 200));
        return;
      }
    }

    const wantColor = activeSwatch.getAttribute('data-color');
    const wantDelivery = activeDelivery ? activeDelivery.getAttribute('data-delivery') : null;

    const variant = card._sklVariants.find(function (v) {
      if (wantDelivery) {
        return v.option1 === wantColor && v.option2 === wantDelivery;
      }
      return v.option1 === wantColor;
    });

    if (!variant) {
      console.warn('[tu-skl] no matching variant for', wantColor, '/', wantDelivery);
      return;
    }

    // Variant-ID am Card setzen
    card.setAttribute('data-resolved-variant-id', variant.id);

    // Hauptbild wechseln mit Fade
    // Image-Fallback: wenn die exakte Variant kein Bild hat (typisch bei Lieferform-Varianten
    // ohne eigenes Image), nimm das Bild einer anderen Variant mit gleichem Stoff (option1)
    let imageToShow = variant.featured_image;
    let srcsetToShow = variant.featured_srcset;
    if (!imageToShow) {
      const fallback = card._sklVariants.find(function (v) {
        return v.option1 === wantColor && v.featured_image;
      });
      if (fallback) {
        imageToShow = fallback.featured_image;
        srcsetToShow = fallback.featured_srcset;
      }
    }

    const img = card.querySelector('[data-skl-card-img]');
    if (img && imageToShow && img.getAttribute('src') !== imageToShow) {
      let swapped = false;
      const swap = function () {
        if (swapped) return;
        swapped = true;
        img.removeEventListener('transitionend', swap);
        img.src = imageToShow;
        if (srcsetToShow) img.srcset = srcsetToShow;
        requestAnimationFrame(function () {
          img.classList.remove('is-fading');
        });
      };
      img.classList.add('is-fading');
      img.addEventListener('transitionend', swap, { once: true });
      setTimeout(swap, 350); // Fallback wenn transitionend nicht feuert
    }

    // Farbnamen-Label updaten
    const colorLabel = card.querySelector('[data-skl-current-color]');
    if (colorLabel) colorLabel.textContent = wantColor;

    // Preis updaten
    const priceEl = card.querySelector('[data-skl-price]');
    if (priceEl && variant.price_formatted) {
      priceEl.textContent = variant.price_formatted;
    }

    // Out-of-Stock-Handling
    const submitBtn = card.querySelector('[data-skl-add]');
    const checkbox = card.querySelector('[data-skl-phone-check]');
    if (submitBtn) {
      if (!variant.available) {
        submitBtn.setAttribute('disabled', '');
        submitBtn.classList.add('is-disabled');
        submitBtn.textContent = 'Ausverkauft';
        submitBtn.setAttribute('data-skl-sold-out', 'true');
      } else if (submitBtn.getAttribute('data-skl-sold-out') === 'true') {
        submitBtn.removeAttribute('data-skl-sold-out');
        submitBtn.textContent = 'In den Warenkorb';
        if (checkbox && checkbox.checked) {
          submitBtn.removeAttribute('disabled');
          submitBtn.classList.remove('is-disabled');
        }
      }
    }
  }

  // ---------- Checkbox ----------
  function initCardCheckbox(card) {
    const checkbox = card.querySelector('[data-skl-phone-check]');
    const submitBtn = card.querySelector('[data-skl-add]');
    if (!checkbox || !submitBtn) return;
    checkbox.addEventListener('change', function () {
      if (submitBtn.getAttribute('data-skl-sold-out') === 'true') return;
      if (checkbox.checked) {
        submitBtn.removeAttribute('disabled');
        submitBtn.classList.remove('is-disabled');
      } else {
        submitBtn.setAttribute('disabled', '');
        submitBtn.classList.add('is-disabled');
      }
    });
  }

  // ---------- Add-to-Cart ----------
  function initCardAddToCart(card) {
    const submitBtn = card.querySelector('[data-skl-add]');
    if (!submitBtn) return;
    submitBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (submitBtn.hasAttribute('disabled')) return;
      handleAddToCart(card, submitBtn);
    });
  }

  function handleAddToCart(card, btn) {
    const variantId = card.getAttribute('data-resolved-variant-id');
    if (!variantId) return;

    const originalLabel = btn.textContent;
    btn.textContent = 'Wird hinzugefügt …';
    btn.setAttribute('disabled', '');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-to-cart failed (' + res.status + ')');
        return res.json();
      })
      .then(function (data) {
        btn.textContent = '✓ Im Warenkorb';

        // ===== UpCart-Drawer öffnen (gleicher 5-Stufen-Fallback wie tu-sale-page) =====
        openUpcartDrawer();

        setTimeout(function () {
          btn.textContent = originalLabel;
          // Checkbox-State weiterhin respektieren
          const checkbox = card.querySelector('[data-skl-phone-check]');
          if (checkbox && checkbox.checked) {
            btn.removeAttribute('disabled');
            btn.classList.remove('is-disabled');
          }
        }, 2000);
      })
      .catch(function (err) {
        btn.textContent = 'Fehler — bitte erneut';
        console.error('[tu-skl] add-to-cart error', err);
        setTimeout(function () {
          btn.textContent = originalLabel;
          const checkbox = card.querySelector('[data-skl-phone-check]');
          if (checkbox && checkbox.checked) {
            btn.removeAttribute('disabled');
            btn.classList.remove('is-disabled');
          }
        }, 2500);
      });
  }

  // ------------------------------------------------------------
  // UpCart-Drawer öffnen — 5-Stufen-Fallback (analog tu-sale-page)
  // ------------------------------------------------------------
  function openUpcartDrawer() {
    // 1. Offizielle UpCart-API
    if (typeof window.openUpcart === 'function') {
      window.openUpcart();
      return;
    }
    // 2. UpCart-spezifisches Event
    document.dispatchEvent(new CustomEvent('upcart:open'));
    // 3. Generisches Cart-Refresh-Event (UpCart lauscht oft mit)
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    // 4. UpCart-Toggle-Element klicken (Fallback)
    const upcartToggle = document.querySelector('.upcart-toggle, [data-upcart-toggle], #upcart-toggle');
    if (upcartToggle && typeof upcartToggle.click === 'function') {
      upcartToggle.click();
      return;
    }
    // 5. Letzter Fallback: Cart-Icon-Klick (öffnet UpCart, da App diesen Klick abfängt)
    const cartIcon = document.querySelector('[data-cart-icon-bubble], [data-header-cart], #cart-icon-bubble, a[href="/cart"]');
    if (cartIcon && typeof cartIcon.click === 'function') {
      cartIcon.click();
    }
  }

  // ------------------------------------------------------------
  // FAQ
  // ------------------------------------------------------------
  function initFaq(root) {
    const items = root.querySelectorAll('[data-skl-faq-item]');
    if (!items.length) return;
    items.forEach(function (item) {
      const trigger = item.querySelector('[data-skl-faq-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        const isOpen = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  // ------------------------------------------------------------
  // Fade-In on Scroll (optional, no jank)
  // ------------------------------------------------------------
  function initFadeIns(root) {
    if (!('IntersectionObserver' in window)) return;
    const targets = root.querySelectorAll('[data-skl-fade]');
    if (!targets.length) return;
    const io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );
    targets.forEach((t) => io.observe(t));
  }
})();